/** Keep role strings in sync with backend/src/constants/roles.js */

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  SUPER_ACCOUNTANT: 'super_accountant',
  MANAGER: 'manager',
  ACCOUNTANT: 'accountant',
  STAFF: 'staff',
  TECHNICIAN: 'technician',
  TECHNICAL_COORDINATOR: 'technical_coordinator',
  ADMIN_OFFICER: 'admin_officer',
  CASHIER: 'cashier'
};

export const ROLE_OPTIONS = [
  { value: 'super_admin', label: 'Super Admin' },
  { value: 'admin', label: 'Administrator' },
  { value: 'manager', label: 'Manager' },
  { value: 'technical_coordinator', label: 'Technical Coordinator' },
  { value: 'admin_officer', label: 'Admin Officer' },
  { value: 'technician', label: 'Technician' },
  { value: 'staff', label: 'Staff' },
  { value: 'cashier', label: 'Cashier' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'super_accountant', label: 'Super Accountant' }
];

export const ADMINS = ['admin', 'super_admin'];

/** Full repair management (except pages gated separately) */
export const REPAIR_MANAGERS = [
  ...ADMINS,
  'manager',
  'branch_manager',
  'staff',
  'branch_staff',
  'technical_coordinator',
  'admin_officer'
];

/** Workshop / SSI / ready-to-collect including technician */
export const REPAIR_WORKSHOP = [...REPAIR_MANAGERS, 'technician'];

export const normalizeRole = (role) =>
  String(role || 'staff')
    .toLowerCase()
    .trim()
    .replace(/[\s-]+/g, '_');
